import React from "react";
import "./ContactUs.css";

const ThankYouPopup = ({ onClose }) => {
  return (
    <div className="thank-you-overlay" onClick={onClose}>
      <div className="thank-you-popup" onClick={(e) => e.stopPropagation()}>
        <button className="thankyou-close-button" onClick={onClose}>
          &times;
        </button>
        <div className="thank-you-icon">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="#29c5ea" strokeWidth="2" fill="rgba(41, 197, 234, 0.1)" />
            <path d="M8 12L10.5 14.5L16 9" stroke="#29c5ea" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h3 className="thank-you-title">Thank You!</h3>
        <p className="thanks-message">
          Thank you for sharing your details! We will get back to you soon.
        </p>
        <p className="thank-you-submessage">
          Meanwhile, talk to our manufacturing expert.
        </p>
        <button className="thank-you-ok-button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default ThankYouPopup;
